<template>
  <div>
    <el-card v-if="customer !== null" shadow="never" v-loading="loading">
      <div class="braintree-info">
        <h1>Customer Info in Braintree</h1>
        <div class="payment-buttons">
          <el-button icon="el-icon-plus" type="primary" @click="() => dialogAddPayment = true" size="small">
            Add Payment Method
          </el-button>
          <el-button
            type="primary"
            v-if="customer.paymentMethods.length === 0"
            @click="() => (dialogFormVisible = true)"
            size="small"
          >
            Request Payment Method
          </el-button>
        </div>
      </div>
      <br/>
      <div class="braintree-info">
        <div>Email: {{ customer.email }}</div>
        <div>Global Id: {{ customer.globalId }}</div>
      </div>
      <h1 style="text-align: left">Payments</h1>
      <div class="payment-toggles">
        <div>
          Autopay:
          <el-switch
            v-model="autopay"
            active-text="Enable"
            inactive-text="Disable"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="updateAutopay"
          >
          </el-switch>
        </div>
        <div>
          Block All:
          <el-switch
            v-model="rsCustomer.blockPayments"
            active-text="Block"
            inactive-text="Unblock"
            active-color="#ff4949"
            inactive-color="#13ce66"
            :disabled="!allowAccess('level_3')"
            @change="() => toggleBlockPayments()"
          >
          </el-switch>
        </div>
        <div>
          ACH:
          <el-switch
              v-model="rsCustomer.blockAchPayments"
              active-text="Block"
              inactive-text="Unblock"
              active-color="#ff4949"
              inactive-color="#13ce66"
              :disabled="!allowAccess('level_3') || rsCustomer.blockPayments"
              @change="() => toggleBlockPayments('ach')"
            >
            </el-switch>
        </div>
        <div>
          Cheque:
          <el-switch
              v-model="rsCustomer.blockChequePayments"
              active-text="Block"
              inactive-text="Unblock"
              active-color="#ff4949"
              inactive-color="#13ce66"
              :disabled="!allowAccess('level_3') || rsCustomer.blockPayments"
              @change="() => toggleBlockPayments('cheque')"
            >
            </el-switch>
        </div>
      </div>
      <el-divider />
      <CustomerOverview
        :customer-details="{ ...rsCustomer }"
        :facility="facility"
        :reload="reloadDataForOverview"
        @update="reloadCustomerData"
        @account="handleAccountdata"
      />
    </el-card>

    <h1 style="text-align: left">Payment Methods</h1>
    <div v-if="!loading && !paymentMethods.length">
      <el-empty description="No Payment Methods"></el-empty>
    </div>
    <div class="payment-methods" v-else-if="loading && !paymentMethods.length">
      <el-card><el-skeleton variant="p" :rows="6" animated/></el-card>
      <el-card><el-skeleton variant="p" :rows="6" animated/></el-card>
      <el-card><el-skeleton variant="p" :rows="6" animated/></el-card>
      <el-card><el-skeleton variant="p" :rows="6" animated/></el-card>
    </div>
    <div class="payment-methods">
      <el-card
        :key="payment.token"
        v-for="payment in paymentMethods"
        v-loading="loading"
      >
        <div style="display: flex; flex-direction: row; justify-content: space-between">
          <div style="text-align: left">
            <img :src="payment.imageUrl" class="image" />
            <p style="margin-top: 0" v-if="payment.cardType">
              {{ payment.cardType }}
            </p>
            <p style="margin-top: 0" v-if="payment.bankName">
              {{ payment.bankName }}
            </p>
          </div>

          <div>
            <div v-if="payment.verification && payment.verification.status === 'verified'" style="display: inline">
              <el-popover
                placement="bottom"
                trigger="hover"
              >
                  <el-table :data="payment.verifications">
                    <el-table-column width="100" property="createdAt" label="Created At"
                    :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
                    >
                      <!-- <template slot-scope="scope">
                        {{ new Date(scope.row.createdAt).toLocaleDateString() }}
                      </template> -->
                    </el-table-column>
                    <el-table-column width="150" property="processorResponseText" label="Response Text"></el-table-column>
                    <el-table-column width="150" property="status" label="Status"></el-table-column>
                    <el-table-column width="150" label="Transaction ID">
                      <template slot-scope="scope">
                        <el-tag v-show="scope.row.networkTransactionId">
                          {{ scope.row.networkTransactionId }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column width="150" label="Verified by">
                      <template slot-scope="scope">
                        <el-tag v-show="scope.row.amount">{{ scope.row.amount }} {{ scope.row.currencyIsoCode }}</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                <el-tag slot="reference" type="success" effect="dark" hit>Verified</el-tag>
              </el-popover>
            </div>
            <div v-if="payment.verified" style="display: inline">
              <el-popover
                placement="bottom"
                trigger="hover"
              >
                <el-table :data="payment.verifications">
                  <el-table-column
                    width="100"
                    property="createdAt"
                    label="Created At"
                    :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
                  >
                    <!-- <template slot-scope="scope">
                      {{ new Date(scope.row.createdAt).toLocaleDateString() }}
                    </template> -->
                  </el-table-column>
                  <el-table-column width="150" property="processorResponseText" label="Response Text"></el-table-column>
                  <el-table-column width="150" property="status" label="Status"></el-table-column>
                  <el-table-column width="150" property="verificationDeterminedAt" label="Verified At"
                  :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
                  >
                    <!-- <template slot-scope="scope">
                      {{ new Date(scope.row.verificationDeterminedAt).toLocaleDateString() }}
                    </template> -->
                  </el-table-column>
                  <el-table-column width="150" property="verificationMethod" label="Verification Method">
                    <template slot-scope="scope">
                      <el-tag>{{ scope.row.verificationMethod }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
                <el-tag slot="reference" type="success" effect="dark" hit>Verified</el-tag>
              </el-popover>
            </div>
            <el-button
              v-if="payment.verified === false && (!payment.verifications || payment.verifications[0].status === 'pending') && !payment.verificationSubmitted"
              size="small"
              @click="() => openVerifyForm(payment)"
            >
              Verification in Process
            </el-button>
            <el-popover
              v-else-if="payment.verifications[0].status === 'pending' && payment.verificationSubmitted"
              placement="bottom"
              trigger="hover"
            >
              <el-card>
                <el-table :data="payment.verifications">
                  <el-table-column width="100" property="createdAt" label="Created At"
                    :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
                  >
                    <!-- <template slot-scope="scope">
                      {{ new Date(scope.row.createdAt).toLocaleDateString() }}
                    </template> -->
                  </el-table-column>
                  <el-table-column width="150" property="processorResponseText" label="Response Text"></el-table-column>
                  <el-table-column width="150" property="status" label="Status"></el-table-column>
                  <el-table-column width="150" label="Transaction ID">
                    <template slot-scope="scope">
                      <el-tag v-show="scope.row.networkTransactionId">
                        {{ scope.row.networkTransactionId }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column width="150" label="Verified by">
                    <template slot-scope="scope">
                      <el-tag v-show="scope.row.amount">{{ scope.row.amount }} {{ scope.row.currencyIsoCode }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
              <!-- <el-tag slot="reference" type="success" effect="dark" hit>Verified</el-tag> -->
              <el-tag slot="reference" type="danger" effect="dark" hit>
                Verification completed, waiting for settlement
              </el-tag>
            </el-popover>
            <el-popover
              v-else-if="payment.verifications[0].status === 'failed' || payment.verifications[0].status === 'processor_declined'"
              placement="bottom"
              trigger="hover"
            >
              <el-card>
                <el-table :data="payment.verifications">
                  <el-table-column width="100" property="createdAt" label="Created At"
                    :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)"
                  >
                    <!-- <template slot-scope="scope">
                      {{ new Date(scope.row.createdAt).toLocaleDateString() }}
                    </template> -->
                  </el-table-column>
                  <el-table-column width="150" property="processorResponseText" label="Response Text"></el-table-column>
                  <el-table-column width="150" property="status" label="Status"></el-table-column>
                  <el-table-column width="150" label="Transaction ID">
                    <template slot-scope="scope">
                      <el-tag v-show="scope.row.networkTransactionId">
                        {{ scope.row.networkTransactionId }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column width="150" label="Verified by">
                    <template slot-scope="scope">
                      <el-tag v-show="scope.row.amount">{{ scope.row.amount }} {{ scope.row.currencyIsoCode }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
              <el-tag slot="reference" type="danger" effect="dark" hit>
              Verification failed
            </el-tag>
              <!-- <el-tag slot="reference" type="success" effect="dark" hit>Verified</el-tag> -->
            </el-popover>
            <el-tag v-if="payment.default" type="success" hit>Primary</el-tag>
            <el-button
              size="small"
              v-else-if="payment.verification ?  payment.verification && payment.verification.status === 'verified' : payment.verified"
              @click="updateDefault(payment)"
            >
              Set to primary
            </el-button>

            <span v-if="payment.bankName"></span>
            <el-dropdown
              hide-on-click
              size="small"
              :type="ccFormBtnBg(payment)"
              v-else-if="payment.doc && payment.doc.statusData && (payment.doc.statusData.status === 'sent' || payment.doc.statusData.status !== 'completed')"
            >
                <span>
                  <el-button :type="ccFormBtnBg(payment)" plain size="small">
                    CC Form Pending
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <div class="dropdown-menu-wrapper">
                    <el-button
                      size="small"
                      v-if="payment.doc && payment.doc.statusData && payment.doc.statusData.status === 'sent'"
                      type="text"
                      icon="el-icon-bell"
                      @click="() => sendReminderEmail(payment.token)"
                    >
                      Send Reminder email to signers
                    </el-button>
                    <el-button
                      size="small"
                      v-if="payment.doc && payment.doc.url"
                      icon="el-icon-view"
                      type="text"
                      @click="() => openPreview(payment.doc)"
                    >
                      View form
                    </el-button>
                    <a
                      v-if="payment.doc && payment.doc.url"
                      :href="payment.doc.url"
                      download
                      >
                        <el-button
                          size="small"
                          type="text"
                          icon="el-icon-download"
                        >
                          Download form
                        </el-button>
                      </a>
                    <el-button
                      size="small"
                      icon="el-icon-close"
                      style="color: red"
                      type="text danger"
                      v-if="payment.doc && payment.doc.statusData && payment.doc.statusData.status !== 'completed'"
                      @click="() => cancelCCAgreement(payment.token)"
                    >
                      Cancel form
                    </el-button>
                    </div>
                  </el-dropdown-menu>
                </span>
            </el-dropdown>
            <el-dropdown hide-on-click v-else-if="!payment.doc || !payment.doc.referenceId">
              <span>
                <el-button :type="ccFormBtnBg(payment)" plain size="small">
                  No CC Form
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <div class="dropdown-menu-wrapper">
                    <el-button
                      icon="el-icon-s-promotion"
                      size="small"
                      type="text"
                      @click="() => sendCCForm(payment.last4, payment.token)"
                    >
                      Send CC Form
                    </el-button>
                  </div>
                </el-dropdown-menu>
              </span>
            </el-dropdown>
            <el-tag v-else-if="payment.doc && payment.doc.statusData && payment.doc.statusData.status === 'completed'" type="success" hit>
              CC Form on File
            </el-tag>
            <el-button type="danger" icon="el-icon-delete" plain size="small" @click="() => deletePayment(payment)"></el-button>
          </div>
        </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div v-if="payment.accountType" style="text-align: left">
          Account Type
          <p style="font-size: 1rem; margin: 0">
            {{ payment.accountType }}
          </p>
        </div>
        <div v-if="payment.ownershipType" style="text-align: left">
          Ownership Type
          <p style="font-size: 1rem; margin: 0">
            {{ payment.ownershipType }}
          </p>
        </div>
      </div>
      <br/>
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div v-if="payment.accountHolderName" style="text-align: left">
          Account Holder Name
          <p style="font-family: monospace; font-size: 1rem; margin: 0">
            {{ payment.accountHolderName }}
          </p>
        </div>
        <div v-if="payment.bankName && payment.last4" style="text-align: left">
          Last 4 numbers
          <p style="font-family: monospace; font-size: 1rem; margin: 0">
            {{ payment.last4 }}
          </p>
        </div>
        <div v-if="payment.routingNumber" style="text-align: left">
          Routing Number
          <p style="font-family: monospace; font-size: 1rem; margin: 0">
            {{ payment.routingNumber }}
          </p>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div v-if="payment.maskedNumber" style="text-align: left">
          Credit Card Number
          <p style="font-family: monospace; font-size: 1rem; margin: 0">
            {{ payment.maskedNumber }}
          </p>
        </div>
        <div v-if="payment.expirationDate" style="text-align: left">
          Expiration
          <p style="font-family: monospace; font-size: 1rem; margin: 0">
            {{ payment.expirationDate }}
          </p>
        </div>
      </div>
    </el-card>
    </div>
    <el-dialog title="CC Form Authorization" :visible.sync="dialogForPdf">
      <PreviewPdf v-if="selectedDocument" :source="selectedDocument" />
    </el-dialog>
    <el-dialog title="New Payment Method" :visible.sync="dialogFormVisible">
      <NewPaymentMethod :first-name="customer.firstName" :email="customer.email" @done="emailSent" />
    </el-dialog>
    <el-dialog title="Add Payment Method" :visible.sync="dialogAddPayment" destroy-on-close>
      <CustomerAddPayment
        :customer-id="customerId"
        :customer="customerData"
        @close="() => dialogAddPayment = false"
        @added-card="addedCard"
        @added-bank="addedCard"
      />
    </el-dialog>
    <el-dialog :visible.sync="verifyDialog" destroy-on-close>
      <el-card v-loading="verifyLoading">
        <template slot="header">
          <el-alert
            title="Verify Micro Transfers"
            type="info"
            :closable="false"
          >
            Two micro transfers have been intiated with customer account on behalf of Paypal.
          </el-alert>
        </template>
        <el-form :model="verifyForm" :inline="true" ref="verifyForm">
          <!-- <el-row :gutter="30"> -->
            <!-- <el-col :span="8" shadow="never"> -->
              <el-form-item
                label="First"
                prop="verifyFirstValue"
                :rules="[
                  { required: true, message: 'Please enter first Transaction value' },
                  { type: 'number', message: 'Transaction must be a number' },
                ]"
              >
                <el-input maxlength="2" v-model.number="verifyForm.verifyFirstValue">
                  <template slot="prepend">
                    $ 0.
                  </template>
                </el-input>
              </el-form-item>
            <!-- </el-col> -->
            <!-- <el-col :span="8"> -->
              <el-form-item
                label="Second"
                prop="verifySecondValue"
                :rules="[
                  { required: true, message: 'Please enter second Transaction value' },
                  { type: 'number', message: 'Transaction must be a number' },
                ]"
              >
                <el-input :maxlength="2" v-model.number="verifyForm.verifySecondValue">
                  <template slot="prepend">
                    $ 0.
                  </template>
                </el-input>
              </el-form-item>
            <!-- </el-col> -->
            <!-- <el-col :span="4"> -->
              <el-form-item>
                <el-button
                  type="primary"
                  :disabled="!(verifyForm.verifyFirstValue && verifyForm.verifySecondValue)"
                  @click="verifyBank"
                >
                  Verify
                </el-button>
              </el-form-item>
            <!-- </el-col> -->
          <!-- </el-row> -->
        </el-form>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { allowAccess } from '../utils/roles';
import { PG_API_BASE, CUSTOMER_API_BASE, CC_TEMPLATE_ID, UPLOAD_API, RS_ANVIL_API } from '../env';
import NewPaymentMethod from './NewPaymentMethod';
import CustomerAddPayment from './CustomerAddPayment';
import CustomerOverview from './CustomerOverview';
import PreviewPdf from './PreviewPdf';
import RsAnvilClient from '../api/rsAnvilApi';
import anvilIntegration from '../utils/anvilIntegration';
import { createCustomerDocument, getCustomerDocuments, deleteCustomerDocument } from '../api/documents';
import { createCustomerNote } from '../api/notes';

export default {
  props: {
    customerId: { type: String, required: true },
    facility: { type: String, required: true },
    customerData: { type: Object, default: () => {} },
  },
  components: {
    NewPaymentMethod,
    CustomerAddPayment,
    CustomerOverview,
    PreviewPdf,
  },
  watch: {
    async customerId() {
      try {
        this.loading = true;
        this.customer = {
          paymentMethods: [],
          firstName: "",
          email: "",
          globalId: "",
        };
        this.rsCustomer = {
          blockPayments: null,
          blockChecquePayments: null,
          blockAchPayments: null,
          autopay: null,
          docs: [],
          primaryContact: null,
          phone: null,
          city: null,
          state: null,
          _id: this.customerId,
        };
        this.payload = {};
        this.paymentMethods = [];
        await this.getCustomerFromBraintree();
        await this.getRsCustomer();
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getCustomerFromBraintree();
    await this.getRsCustomer();
    this.autopay = this.rsCustomer.autopay;
    this.loading = false;
  },
  data() {
    return {
      reloadDataForOverview: false,
      customer: {
        paymentMethods: [],
        firstName: "",
        email: "",
        globalId: "",
      },
      rsCustomer: {
        blockPayments: null,
        blockChecquePayments: null,
        blockAchPayments: null,
        autopay: null,
        docs: [],
        primaryContact: null,
        phone: null,
        city: null,
        state: null,
        _id: this.customerId,
      },
      payload: {},
      account: null,
      paymentMethods: [],
      loading: true,
      dialogFormVisible: false,
      dialogAddPayment: false,
      verifyDialog: false,
      verifyLoading: false,
      autopay: false,
      achVerifications: [],
      verifyForm: {
        verifyFirstValue: null,
        verifySecondValue: null,
      },
      selectedPayment: null,
      selectedDocument: null,
      dialogForPdf: false,
    };
  },
  methods: {
    ccFormBtnBg(payment) {
      if (payment.doc && payment.doc.statusData && payment.doc.statusData.status === 'sent') {
        return 'warning';
      }

      return '';
    },
    allowAccess(role) {
      return allowAccess(role, this.$keycloak, this.$root.state.facility);
    },
    async toggleBlockPayments(payment) {
      this.loading = true;
      const response = await axios.put(`${CUSTOMER_API_BASE}/customers/v1/${this.customerId}/payments`, {
        ...(!payment ? { blockPayments: this.rsCustomer.blockPayments } : {}),
        ...(payment === 'ach' ? { blockAchPayments: this.rsCustomer.blockAchPayments } : {}),
        ...(payment === 'cheque' ? { blockChequePayments: this.rsCustomer.blockChequePayments } : {}),
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.rsCustomer = response.data;
      this.autopay = this.rsCustomer.autopay;
      this.loading = false;
    },
    handleAccountdata(data) {
      this.account = data;
    },
    async reloadCustomerData() {
      this.$emit('reload-customer');
      await this.getCustomerFromBraintree();
      await this.getRsCustomer();
    },
    openPreview(doc) {
      this.selectedDocument = doc.url;
      this.dialogForPdf = true;
    },
    async sendReminderEmail(token) {
      const [doc] = this.rsCustomer.docs.filter(item => item.referenceId === token);
      if (doc.documentEid) {
        const rsAnvilClient = new RsAnvilClient(this.$keycloak.token);

        await rsAnvilClient.sendReminderToSigners(doc.documentEid);
        this.$message.success({
          message: 'Sent email reminder to signer(s).',
        });
      } else {
        this.$message.warning({
          message: 'Document EID not found!',
        });
      }
    },
    async sendCCForm(last4, token) {
      this.loading = true;
      try {
        if (!this.rsCustomer.primaryContact) {
          this.rsCustomer.primaryContact = {
            name: this.rsCustomer.fullName,
          };
        }

        if (!this.rsCustomer.primaryContact.name || !this.rsCustomer.phone || !this.rsCustomer.city || !this.rsCustomer.state) {
          this.$message.warning({
            title: 'Failed',
            message: 'Customer Profile is missing required information.',
          });
          this.loading = false;
          return;
        }

        const anvilResponse = await axios.get(`${RS_ANVIL_API}/cast/${CC_TEMPLATE_ID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

        const payloadFields = anvilResponse.data.cast.fieldInfo.fields;
        const payloadTypeId = payloadFields.map(item => item.id);
        const options = 'CreditCard';
        const anvil = anvilIntegration(this.rsCustomer, this.$root.state.facilityData, null, null, options, last4);

        payloadTypeId.forEach((item) => {
          this.payload[item] = `${typeof anvil[item]}` === 'function' ? anvil[item]() : anvil[item];
        });

        const rsAnvilClient = new RsAnvilClient(this.$keycloak.token);

        const response = await rsAnvilClient.generateCCAgreement({
          payload: this.payload,
          name: this.rsCustomer.primaryContact.name,
          customerId: this.rsCustomer._id,
          replyToEmail: this.$root.state.facilityData && this.$root.state.facilityData.email ? this.$root.state.facilityData.email : this.$keycloak.tokenParsed.email,
        });

        // const signerEid = response.data.createEtchPacket.documentGroup.signers[0].eid;
        const documentEid = response.data.data.createEtchPacket.eid;
        const documentGroupEid = response.data.data.createEtchPacket.documentGroup.eid;

        if (!this.rsCustomer.docs) {
          this.rsCustomer.docs = [];
        }

        await createCustomerDocument(this.rsCustomer._id, {
          createdAt: new Date(),
          createdBy: this.$keycloak.tokenParsed ? this.$keycloak.tokenParsed.email : '',
          documentEid,
          documentGroupEid,
          documentUrl: response.data.data.createEtchPacket.detailsURL,
          type: 'CREDIT_CARD_AUTHORIZATION',
          templateId: CC_TEMPLATE_ID,
          referenceId: token,
        }, true, this.$keycloak.token);
        this.rsCustomer.docs = this.rsCustomer.docs.filter(item => item.referenceId !== token || !item.referenceId);
        this.$message.success({
          title: 'Sent',
          message: 'Succesfully sent CC Form to customer',
        });

        await this.getRsCustomer();
      } catch (err) {
        console.log(err);
      }

      this.loading = false;
    },
    async getRsCustomer() {
      this.loading = true;
      const response = await axios.get(
        `${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      this.rsCustomer = response.data;
      const docsResponse = await getCustomerDocuments(this.customerId, true, this.$keycloak.token);
      this.rsCustomer.docs = docsResponse.data;

      for (const paymentMethod of this.customer.paymentMethods) {
        const [foundDoc] = this.rsCustomer.docs.filter(item => item.referenceId === paymentMethod.token);

        const documentDownloaded = (foundDoc && foundDoc.url);
        if (foundDoc && foundDoc.documentEid !== undefined) {
          const response = await this.getDocumentSignStatus(foundDoc);

          if (response.data && response.data.data && response.data.data.etchPacket) {
            foundDoc.statusData = response.data.data.etchPacket;
          }

          if (!documentDownloaded && foundDoc.statusData.status === 'completed') {
            const agreementBuffer = await this.getDocumentBuffer(foundDoc);

            const formData = new FormData();
            const buffer = new Uint8Array(agreementBuffer.data.data);
            const blob = new Blob([buffer], { type: 'application/pdf' });
            formData.append('document', blob, `${foundDoc.documentEid}.pdf`);

            const response = await axios.post(UPLOAD_API, formData, {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
                'Content-Type': 'multipart/form-data',
              },
            });

            this.rsCustomer.docs.forEach((item) => {
              if (item.referenceId === foundDoc.referenceId) {
                item.url = response.data.url;
              }
            });

            await axios.put(
              `${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`,
              {
                docs: this.rsCustomer.docs,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.$keycloak.token}`,
                },
              },
            );
          }
        }

        paymentMethod.doc = foundDoc ? { ...foundDoc } : null;
      }

      this.paymentMethods = this.customer.paymentMethods;

      this.loading = false;
    },
    async updateAutopay(value) {
      this.loading = true;

      const note = {
        type: "Profile Changes",
        facility: this.facility,
        overall: false,
        description: JSON.stringify({ autopay: value, changedBy: this.$keycloak.tokenParsed.name })
      };
      try {
        await axios.put(`${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`, {
          autopay: value,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        await createCustomerNote(this.customerId, note, this.$keycloak.token);
      } catch (error) {
        this.$message.error({
          message: 'Could not update Autopay option',
        });
        this.loading = false;
        return;
      }

      this.$message({
        type: value ? 'success' : 'warning',
        message: 'Updated autopay option',
      });
      this.$emit('reload-customer');

      this.loading = false;
    },
    openVerifyForm(item) {
      this.selectedPayment = item;
      this.verifyDialog = true;
    },
    async verifyBank() {
      this.$refs.verifyForm.validate(async (valid) => {
        if (valid) {
          this.verifyLoading = true;
          let response = await axios.put(
            `${PG_API_BASE}/customer/payment/bank/verify/micro/transfers/${this.selectedPayment.verifications[0].id}`,
            {
              first: this.verifyForm.verifyFirstValue,
              second: this.verifyForm.verifySecondValue,
            },
            {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            },
          );

          response = await axios.post(`${CUSTOMER_API_BASE}/customers/v1/ach/verfications/${this.customerId}`, {
            id: this.selectedPayment.verifications[0].id,
            customerId: this.customerId,
            submitted: true,
            token: this.selectedPayment.token,
            verifiedBy: this.$keycloak.tokenParsed.email,
            details: {
              first: this.verifyForm.verifyFirstValue,
              second: this.verifyForm.verifySecondValue,
            },
          }, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

          if (!response.data.success) {
            this.verifyLoading = false;
            this.$message({
              type: 'error',
              message: response.data.message,
            });
            return;
          }

          this.$message({
            type: 'success',
            message: 'The payment method may take 3 days to complete the settlement and mark as verified.',
          });
          this.verifyLoading = false;
          this.verifyDialog = false;

          await this.getCustomerFromBraintree();
          await this.getRsCustomer();
        }
      });
    },
    async addedCard() {
      this.dialogAddPayment = false;
      await this.getCustomerFromBraintree();
      await this.getRsCustomer();
    },
    async updateDefault(payment) {
      try {
        this.loading = true;
        await axios.put(
          `${PG_API_BASE}/customer/${payment.customerId}`,
          {
            defaultPaymentMethodToken: payment.token,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );

        await this.getCustomerFromBraintree();
        await this.getRsCustomer();

        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    async deletePayment(item) {
      try {
        this.loading = true;
        await axios.delete(`${PG_API_BASE}/customer/payment/${item.token}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        await this.getCustomerFromBraintree();
        await this.getRsCustomer();
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$message({
          type: 'error',
          message: err.message,
        });
      }
    },
    async getSubmittedVerifications() {
      const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/ach/verfications/${this.customerId}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });


      this.achVerifications = response.data;

      this.customer.paymentMethods.forEach((method) => {
        const { token } = method;

        const [foundLocalVerification] = this.achVerifications.filter(item => item.token === token);

        if (foundLocalVerification && foundLocalVerification.submitted) {
          method.verificationSubmitted = true;
        }
      });
    },
    async getCustomerFromBraintree() {
      this.loading = true;
      const response = await axios.get(
        `${PG_API_BASE}/customer/${this.customerId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      this.customer = response.data.customer;
      await this.getSubmittedVerifications();
      this.loading = false;
    },
    emailSent() {
      this.dialogFormVisible = false;
      this.$notify.success({
        title: 'Success',
        message: 'Requested customer to add payment details.',
      });
    },
    async getDocumentSignStatus(doc) {
      const rsClient = new RsAnvilClient(this.$keycloak.token);
      const response = await rsClient.getSignersStatus(doc.documentEid);
      return response;
    },
    async getDocumentBuffer(doc) {
      const rsClient = new RsAnvilClient(this.$keycloak.token);
      const agreementBuffer = await rsClient.downloadAgreement(doc.documentGroupEid);

      return agreementBuffer;
    },
    async cancelCCAgreement(token) {
      this.loading = true;

      try {
        const rsAnvilClient = new RsAnvilClient(this.$keycloak.token);
        const [foundDoc] = this.rsCustomer.docs.filter(item => item.referenceId === token);

        await rsAnvilClient.cancelAgreement(foundDoc.documentEid, foundDoc.documentGroupEid);
        await deleteCustomerDocument(
          this.customerId,
          foundDoc._id,
          foundDoc.signed,
          this.$keycloak.token,
        );
      } catch (error) {
        this.$message.error({
          message: 'There was an error cancelling the CC Form',
        });
        console.log(error);
      }

      await this.getRsCustomer();
    },
  },
};
</script>

<style scoped>
.payment-methods {
  margin-top: 1.5rem;
  /* align-content: space-between; */
  display: flex;
  flex-direction: column;
  /* flex-wrap: wrap; */
  gap: 1rem;
}

.el-dropdown-menu.el-popper {
  width: 15rem;
}

.dropdown-menu-wrapper{
  padding-left: 1rem;
}

.dropdown-menu-wrapper * {
  text-decoration: none;
  margin-left: 0;
  text-align: left;
  width: 100%
}

.dropdown-menu-wrapper .el-button:hover {
  opacity: 0.65
}

.braintree-info, .payment-buttons {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
  text-align: left;
}

.payment-buttons .el-button+.el-button {
  margin-left: 0;
}

.payment-toggles {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: left;
}

@media (min-width: 768px) {
  .payment-methods {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .payment-toggles {
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
  }

  .braintree-info {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  .payment-buttons {
    max-width: 50%;
    align-items: center;
    flex-direction: row;
    justify-content: end
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerBraintree.vue